globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { AccordionV2 } from './accordion-v2';
import Title from '../title';
import IconButton from '../icon-button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SectionAccordion(_ref) {
  var children = _ref.children,
      toggleBtn = _ref.toggleBtn,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? true : _ref$open,
      headerRef = _ref.headerRef,
      iconButton = _ref.iconButton,
      title = _ref.title,
      onClickIconButton = _ref.onClickIconButton;
  return /*#__PURE__*/_jsxs(_StyledAccordionV, {
    open: open,
    children: [/*#__PURE__*/_jsxs(HeaderWrapper, {
      twStyle: toggleBtn === null || toggleBtn === void 0 ? void 0 : toggleBtn.wrapperStyle,
      ref: headerRef,
      children: [/*#__PURE__*/_jsxs(TitleAndButtonWrapper, {
        children: [/*#__PURE__*/_jsx(Title, {
          fontSize: "large",
          fontWeight: "semibold",
          textColor: "neutral-700",
          twStyle: {
            "minWidth": "fit-content",
            "whiteSpace": "nowrap",
            "fontSize": "1.125rem",
            "lineHeight": "1.5",
            "@media (min-width: 768px)": {
              "fontSize": "1.25rem",
              "lineHeight": "1.75rem"
            }
          },
          wrapperStyle: {
            "display": "flex"
          },
          children: title
        }), (iconButton === null || iconButton === void 0 ? void 0 : iconButton.Icon) && /*#__PURE__*/_jsx(IconButton, {
          Icon: iconButton.Icon,
          ariaLabel: (iconButton === null || iconButton === void 0 ? void 0 : iconButton.ariaLabel) || '',
          onClick: onClickIconButton
        })]
      }), /*#__PURE__*/_jsx(_StyledAccordionV2Button, {
        IconComponent: (toggleBtn === null || toggleBtn === void 0 ? void 0 : toggleBtn.Icon) || ChevronDownIcon,
        wrapperStyle: [{
          "display": "flex",
          "alignItems": "center",
          "justifyContent": "flex-end"
        }]
      })]
    }), /*#__PURE__*/_jsx(_StyledAccordionV2Panel, {
      children: children
    })]
  });
}
export default SectionAccordion;

var HeaderWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "accordion-v2section__HeaderWrapper",
  componentId: "sc-sufctj-0"
})(["", " ", ""], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "paddingBottom": "1.5rem"
}, function (_ref2) {
  var twStyle = _ref2.twStyle;
  return twStyle || {};
});

export var TitleAndButtonWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "accordion-v2section__TitleAndButtonWrapper",
  componentId: "sc-sufctj-1"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.75rem"
});

var _StyledAccordionV = /*#__PURE__*/_styled(AccordionV2).withConfig({
  displayName: "accordion-v2section___StyledAccordionV",
  componentId: "sc-sufctj-2"
})({
  "borderRadius": "0px",
  "backgroundColor": "transparent"
});

var _StyledAccordionV2Button = /*#__PURE__*/_styled(AccordionV2.Button).withConfig({
  displayName: "accordion-v2section___StyledAccordionV2Button",
  componentId: "sc-sufctj-3"
})({
  "width": "fit-content",
  "borderRadius": "0px",
  "backgroundColor": "transparent",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
});

var _StyledAccordionV2Panel = /*#__PURE__*/_styled(AccordionV2.Panel).withConfig({
  displayName: "accordion-v2section___StyledAccordionV2Panel",
  componentId: "sc-sufctj-4"
})({
  "paddingTop": "0px",
  "paddingBottom": "0px"
});